import { Checkbox, DataSource, Label, Layout, Panel, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutClaimsDetail extends Layout {
    checkboxExcludeOrderType: Checkbox;
    checkboxExcludeReasonCodes: Checkbox;
    labelAdded: Label;
    labelClaimsDetail1: Label;
    labelClaimsDetail3: Label;
    labelClaimsDetail4: Label;
    labelDividend: Label;
    labelDivisor: Label;
    labelLeftParen: Label;
    labelRightParen: Label;
    labelSubtracted: Label;
    labelWeight: Label;
    panelFormula: Panel;
    sourceCarrierScorecardDetail: DataSource;
    tabScoringDetails: Tab;
    tabsetScoringDetails: Tabset;
    textboxClaimReasonCodes: Textbox;
    textboxEndOfPeriod: Textbox;
    textboxMinimumRecords: Textbox;
    textboxOrderType: Textbox;
    textboxStartOfPeriod: Textbox;
    textboxWeight: Textbox;
}
